<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-column w-100">
                        <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-3"
                             :key="objectKey + '-header'">
                            <span class="h3 mb-2 mb-lg-0" v-if="!object.id">
                                <span>Тематика</span>
                            </span>
                            <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                            <sup><small v-if="!object.id" class="text-secondary ml-2">Новая</small></sup>
                        </div>
                    </div>

                </div>

            </div>


            <div id="questionGroupForm">

                <b-form-row>

                    <form-field
                                 class="col-xs-12 col-lg-6 required m-2"
                                 :label="getFieldLabel('name')"
                                 :editable="getAbility('name')"
                                 :value="object.name"
                                 :feedback="liveFeedback('name')">
                        <template #field>
                            <b-form-input
                                id="text"
                                class="w-100"
                                type="text"
                                v-model="$v.form.name.$model"
                                :state="validateState('name')">
                            </b-form-input>
                        </template>
                    </form-field>


                  <form-field class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-1 required m-2"
                               :label="getFieldLabel('listOrder')"
                               :editable="getAbility('listOrder')"
                               :value="getObjectField('listOrder')"
                               :feedback="liveFeedback('listOrder')">
                      <template #field>
                          <b-form-input
                              id="listOrder"
                              class="w-100"
                              type="number"
                              v-model="$v.form.listOrder.$model"
                              :state="validateState('listOrder')">
                          </b-form-input>
                      </template>
                  </form-field>
                </b-form-row>

            </div>

            <object-form-buttons :has-changes="hasChanges"
                     :object-exists="Boolean(object.id)"
                     @object-create="onCreate"
                     @object-update="updateObject"
                     @object-cancel-changes="cancelChanges" class="mb-5"/>


        </b-card>

        <stub v-else :failed-loading="failedLoading"/>

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>


    </div>

</template>

<script>
import ObjectFormButtons from "@/components/Forms/ObjectFormButtons.vue";
import Stub from "@/components/Stub.vue";
import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal.vue";
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import FormField from "@/components/Forms/FormField.vue";
import { QuestionGroup } from "@/pages/AppPages/Catalogs/FAQ/questionGroup";
import api from "@/api";

export default {
    name: "QuestionGroupDetail",
    components: {FormField, ConfirmLeaveModal, Stub, ObjectFormButtons},
    mixins: [
        ObjectComponentMixin
    ],
    validations() {
        return this.objectClass ? {form: this.objectClass.validations} : {}
    },
    mounted() {
        const vm = this;
        this.onMount();
        this.resetForm().then(() => {
            if (vm.$v.form.$anyDirty) {
                vm.$v.$reset();
            }
        });
    },
    beforeMount() {
        const vm = this;
        vm.objectClass = QuestionGroup;
        vm.objectId = vm.$route.params.id;
        vm.apiEntryPoint = api.questionGroups;
        vm.backRoute = 'questionGroupList';
        vm.nextRoute = 'questionGroupDetail';

        vm.initObjectParams = {};

    }
}
</script>

<style scoped>

</style>